<template>
  <Modal
    :title="$t('create_item_color')"
    modalId="create-modal"
    @submit="submitItemColor"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitItemColor">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('item_color_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="itemColor.color"
          class="form-control"
        />
        <div v-if="errors.color" class="text-danger mt-2">
          <span>{{ errors.color }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls";
import {useToast} from "vue-toastification";

export default {
   components: {
      Modal,
    },

   data() {
    return {
      itemColor: {
        color: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
      async submitItemColor() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.itemColor.color) this.errors.color = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
          return; // Stop execution if validation fails
        }

        try {
          const formData = new FormData();
          Object.keys(this.itemColor).forEach((key) => {
            formData.append(key, this.itemColor[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.item_color.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Color successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.itemColor.color = "";
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
